const fetchServiceProvider = (state, payload) => {
  state.serviceProviderList = payload.data;
}

const fetchRates = (state, payload) => {
  state.rateList = payload.data;
}

const getSiteList = (state, payload) => {
  state.siteList = payload.data;
}

const getSiteDetails = (state, payload) => {
  state.siteDetails = payload;
}



export default {
  getSiteList,
  getSiteDetails,
  fetchRates,
  fetchServiceProvider

}


// WEBPACK FOOTER //
// ./src/store/modules/siteManagement/mutations.js